import React, { Component } from "react";

class test extends Component {
  constructor(props) {
    super(props);
    this.state = { values: [], myvalues: [], myindex: 1 };
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  createUI() {
    return this.state.values.map((el, i) => (
      <div key={i}>
        <input
          type="text"
          value={el || ""}
          onChange={this.handleChange.bind(this, i)}
        />
        {/* <input type='button' value='remove' onClick={this.removeClick.bind(this, i)}/> */}
      </div>
    ));
  }

  handleChange(i, event) {
    let values = [...this.state.values];
    // let myvalues = [...this.state.values];
    // let myindex=this.state.myindex;
    values[i] = event.target.value;
    this.setState({ values });
    // myvalues[i+1] = { myindex : values[i] };
    // this.setState({ myvalues,myindex:myindex+1 });
  }

  addClick() {
    this.setState((prevState) => ({ values: [...prevState.values, ""] }));
  }

  removeClick(i) {
    let values = [...this.state.values];
    values.splice(i, 1);
    this.setState({ values });
  }

  handleSubmit(event) {
    this.state.values.map((itemname, indexitem2) => console.log(itemname));
    alert("A name was submitted: " + this.state.values.join(", "));
    event.preventDefault();
  }

  render() {
    return (
      <div>
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
       
      </div>
    );
  }
}

export default test;
